import { ChangeEvent } from "react";
import { Input } from "barte-design-system";
interface BankSlipInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function BankSlipInput({ value, onChange }: BankSlipInputProps) {
  const formatBoleto = (raw: string): string => {
    const onlyDigits = raw.replace(/\D/g, "");
    // BOLETO DE ARRECADAÇÃO (48 dígitos)
    if (onlyDigits.length >= 48) {
      return onlyDigits
        .replace(/^(\d{11})(\d{1})(\d)/, "$1-$2 $3")
        .replace(/^(\d{11}-\d{1} \d{11})(\d{1})(\d)/, "$1-$2 $3")
        .replace(/^(\d{11}-\d{1} \d{11}-\d{1} \d{11})(\d{1})(\d)/, "$1-$2 $3")
        .replace(/^(\d{11}-\d{1} \d{11}-\d{1} \d{11}-\d{1} \d{11})(\d{1})/, "$1-$2")
        .slice(0, 60);
    }
    //  BOLETO BANCÁRIO (47 dígitos)
    if (onlyDigits.length <= 47) {
      return onlyDigits
        .replace(/^(\d{5})(\d)/, "$1.$2")
        .replace(/^(\d{5}\.\d{5})(\d)/, "$1 $2")
        .replace(/^(\d{5}\.\d{5} \d{5})(\d)/, "$1.$2")
        .replace(/^(\d{5}\.\d{5} \d{5}\.\d{6})(\d)/, "$1 $2")
        .replace(/^(\d{5}\.\d{5} \d{5}\.\d{6} \d{5})(\d)/, "$1.$2")
        .replace(/^(\d{5}\.\d{5} \d{5}\.\d{6} \d{5}\.\d{6})(\d)/, "$1 $2")
        .slice(0, 54);
    }
    return onlyDigits.slice(0, 48);
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formatted = formatBoleto(e.target.value);
    onChange(formatted);
  };

  return (
    <Input
      placeholder="00000.00000 00000.000000 00000.000000 0 00000000000000"
      value={value}
      onChange={(e) => handleChange(e as ChangeEvent<HTMLInputElement>)}
      maxLength={60}
    />
  );
}
